import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'gungTransformCurrency',
  standalone: false
})
export class GungTransformCurrencyPipe implements PipeTransform {
  transform(code: string, currencyDisplay: 'symbol' | 'narrowSymbol' | 'code' | 'name' = 'symbol'): string {
    try {
      const formatted = new Intl.NumberFormat('en', {
        style: 'currency',
        currency: code,
        currencyDisplay,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(1);

      // For 'symbol' and 'narrowSymbol', extract just the symbol
      if (currencyDisplay === 'symbol' || currencyDisplay === 'narrowSymbol') {
        const symbol = formatted.replace(/1|[\d.,]/g, '').trim();
        return symbol || code;
      }

      // For 'code' or 'name', return the whole formatted result minus the number
      return formatted.replace(/1|[\d.,]/g, '').trim() || code;
    } catch (e) {
      return code;
    }
  }
}
